import Box from '@mui/material/Box';
import React, { useState } from 'react';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { useDispatch } from 'react-redux';
import esg from '../../../assets/images/esg-baner.jpg';
import {
  Wrapper,
  BoxStyled,
  BarChartIconStyled,
  BarChartIconWrapper,
} from './ESGLearnMoreBar.styled';
import { ESGLearnMoreModal } from '../Modals/ESGLearnMoreModal/ESGLearnMoreModal';
import { MessageModal } from '../../../ui/Modals';
import { sendMessageToSales } from '../../shop/services';
import { addNotificationAction } from '../../../store/notifications/notificationsActions';

export const ESGLearnMoreBar = () => {
  const dispatch = useDispatch();
  const [openModal, setModalOpen] = useState(false);
  const [messageModalOpen, setMessageModalOpen] = useState(false);
  const toggleModal = () => setModalOpen(!openModal);
  const toggleMessageModal = () => {
    setModalOpen(!openModal);
    setMessageModalOpen(!messageModalOpen);
  };

  const sendMessage = (messageData: string) => {
    sendMessageToSales(messageData)
      .then(() => {
        dispatch(
          addNotificationAction({
            message: 'Message sent successfully',
            variant: 'success',
          }),
        );
      })
      .catch(() => {
        dispatch(
          addNotificationAction({
            message: 'Failed to send a message',
            variant: 'error',
          }),
        );
      });
  };

  return (
    <Wrapper mb={4}>
      <img src={esg} alt="" />
      <BoxStyled>
        <Box display="flex" alignItems="center">
          <BarChartIconWrapper mr={2}>
            <BarChartIconStyled />
          </BarChartIconWrapper>
          <Box>
            <Typography fontWeight="bold">Interested in ESG Impact assessment?</Typography>
            <Typography variant="subtitle2">
              Learn more about the relative position of company in the industry.
            </Typography>
          </Box>
        </Box>
        <Button variant="outlined" onClick={toggleModal}>
          LEARN MORE
        </Button>
      </BoxStyled>
      <ESGLearnMoreModal
        onClose={toggleModal}
        open={openModal}
        onContactSales={toggleMessageModal}
      />
      <MessageModal
        title="Contact Sales"
        open={messageModalOpen}
        onClose={toggleMessageModal}
        onSendMessage={sendMessage}
      />
    </Wrapper>
  );
};
